import { createAction } from '@reduxjs/toolkit'
import { all, call, put, select, takeEvery } from 'redux-saga/effects'

import { updateDocumentChunk } from '../../../api/projects-api'
import { DocumentChunk } from '../../../models/documentChunk'
import { selectDocumentChunks, updateSingleDocumentChunk } from '../../slices/documents'

export const updateDocumentsFlagTextAction =
    createAction<{ id: number; flagText: string | null }[]>('updateDocumentsFlagText')

export function* updateDocumentChunkInStoreAndAPI(id: number, flagText: string | null, chunks: DocumentChunk[]) {
    const documentChunk = chunks.find((chunk) => chunk.id === id)

    if (!documentChunk) return

    try {
        const updatedChunk: DocumentChunk = yield call(updateDocumentChunk, id, null, {
            flag_text: flagText,
        })

        yield put(updateSingleDocumentChunk(updatedChunk))
    } catch (e) {
        yield call(console.error, e)
        yield put(updateSingleDocumentChunk(documentChunk))
    }
}

export function* handleUpdateDocumentsFlagText(action: ReturnType<typeof updateDocumentsFlagTextAction>) {
    const chunks: DocumentChunk[] = yield select(selectDocumentChunks)

    if (chunks.length === 0) return

    yield all(
        action.payload.map(({ id, flagText }) => {
            return call(updateDocumentChunkInStoreAndAPI, id, flagText, chunks)
        })
    )
}

export function* watchForUpdateDocumentsFlagText() {
    yield takeEvery(updateDocumentsFlagTextAction, handleUpdateDocumentsFlagText)
}
